import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z","key":"svg-0"}],["path",{"d":"M15 14v-4l3 4v-4","key":"svg-1"}],["path",{"d":"M6 14v-4l3 4v-4","key":"svg-2"}],["path",{"d":"M12 10.5l0 .01","key":"svg-3"}],["path",{"d":"M12 13.5l0 .01","key":"svg-4"}]]

const IconRelationManyToMany = createReactComponent('outline', 'relation-many-to-many', 'RelationManyToMany', __iconNode);

export default IconRelationManyToMany;